/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./styles/Navbar-footer.css";

// import bellIcon from "../assets/Vector.png";
import Profie from "../assets/icons8-male-user-50.png";
import { useNavigate } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { Spin, Avatar } from "antd";
// import Cookies from "universal-cookie";
import { LogoutOutlined, SecurityScanOutlined } from "@ant-design/icons";
import Axios from "../api/Axios";
import { IMAGE_LINK, REDIRECT_PROFILE } from "../config";
import { useSelector } from "react-redux";
import ModalTesting from "./AdminComponents/Modals/Modaltesting";
import Down from "../assets/icons/downoutlined_.png";
import ViewUpdateIndex from "./AdminComponents/ViewUpdateIndex";
import { MAIN_LOGO_BIG, MAIN_LOGO_OPTION_2 } from "../ImagesSrc";
const NavBar = (props) => {
  const [firstName, setFirstname] = useState();
  const [lastName, setLastName] = useState();
  const [loading, setLoading] = useState(true);
  const userInfo = useSelector((state) => state.user);
  const handleProfileClick = () => {
    window.location.href = REDIRECT_PROFILE;
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const firstLetter = userInfo?.data?.first_name?.[0]?.toUpperCase();
  //console.log(firstLetter, userInfo);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const HandleModalClose = () => {
    setIsModalVisible(false);
  };
  const history = useNavigate();
  const settingData = () => {
    setFirstname(props.data.first_name);
    setLastName(props.data.last_name);
    setLoading(false);
  };
  useEffect(() => {
    settingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async () => {
    try {
      const res = await Axios.get("/logout/");
      localStorage.removeItem("token");
      localStorage.clear();
      //console.log(res);
      history("/");
    } catch (err) {
      //console.log(err);
    }
  };

  const items = [
    {
      label: (
        <strong>
          Hello {firstName?.charAt(0).toUpperCase() + firstName?.slice(1)}
        </strong>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "1",
      label: (
        <div onClick={handleProfileClick} style={{ cursor: "pointer" }}>
          <SecurityScanOutlined onClick={handleProfileClick} />
          <button
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            &nbsp; View Profile
          </button>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleLogout} style={{ cursor: "pointer" }}>
          <LogoutOutlined onClick={handleLogout} />
          <button
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            &nbsp; Logout
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="container">
      <div className="flex-container">
        <img
          alt=""
          src={MAIN_LOGO_BIG}
          width="140"
          height="34"
          className="imgStyle"
        />
        {/* <div className="textsNav"> */}
        {loading ? (
          <>
            <Spin style={{ padding: "1.5rem" }} />
          </>
        ) : (
          <>
            <div className="textsNav1--21">
              <div
                className="texts-navv2"
                onClick={showModal}
                style={{ cursor: "pointer" }}
              >
                {/* <img
                  alt=""
                  src={Profie}
                  width="30"
                  height="30"
                  // className="Profile"
                  // style={{ cursor: "pointer" }}
                /> */}{" "}
                {userInfo?.data?.profile_pic ? (
                  <>
                    <Avatar size={30} src={userInfo?.data?.profile_pic} />
                  </>
                ) : (
                  <>
                    <Avatar
                      size={30}
                      style={{
                        backgroundColor: "#b3cee5",
                        color: "#0000B9",
                        fontWeight: "500",
                        fontSize: "18px",
                      }}
                    >
                      {firstLetter}
                    </Avatar>
                  </>
                )}
                {/* </Dropdown> */}
                <div className="newText1" style={{ color: "black" }}>
                  {userInfo?.data?.first_name}
                </div>
              </div>
            </div>
            <ModalTesting
              visible={isModalVisible}
              handleClose={HandleModalClose}
              userInfo={userInfo?.data}
            />
          </>
        )}
        {/* </div> */}
      </div>
    </div>
  );
};

export default NavBar;
